// extracted by mini-css-extract-plugin
export var optionGrid = "_8y-7";
export var optionList = "_8y-6";
export var questionsBlock = "_8y-9";
export var spacer = "_8y-5";
export var stepCenteredContent = "_8y-3";
export var stepInner = "_8y-0";
export var stepInnerFullWidth = "_8y-1";
export var stepInnerLockScroll = "_8y-2";
export var stepTransitionFrame = "_8y-4";
export var welcomeBlock = "_8y-8";